export default __webpack_public_path__ + "static/media/image25.7eac9552.png";